//src/styles/components/MuiAppBar.js

import palette from "../palette";

const MuiAppBar = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: palette.primary?.main || "#1976d2", 
      color: palette.primary?.contrastText || "#ffffff", 
      backgroundImage: "none", 
      boxShadow: theme?.shadows?.[4] || "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)" 
    }),
  },
};

export default MuiAppBar;